export default __webpack_public_path__ + "static/media/TN_logo.ed6a5cae.png";